import styled from 'styled-components';

export const InputWithIcon = styled.div`
  height: 35px;
  width: 258px;
  border: 1px solid #e4e4e4;
  border-radius: 2px;
  padding: 0 8px;
  input {
    border: none;
    padding: 8px 0;
  }
  input:active,
  input:focus {
    border: none;
    outline: none;
  }
  .clear {
    width: 15px;
    border-radius: 50%;
    background-color: #f2f2f2;
    color: #c1bdbd;
    cursor: pointer;
    margin-left: 5px;
    padding: 0px;
    border: none;
    font-size: 15px;
    line-height: 1;
    height: 15px;
  }
`;
